const SYMBOL_FOR_ZERO = "—";
const SYMBOL_FOR_THOUSAND = 'тыс';
const SYMBOL_FOR_MILLION = 'млн';
const SYMBOL_FOR_BILLION = 'млрд'
const SYMBOL_FOR_THOUSAND_ENG = 'k';
const SYMBOL_FOR_MILLION_ENG = 'kk';
const SYMBOL_FOR_BILLION_ENG = 'kkk'

const SYMBOLS = {
    ru: {
        thousand: SYMBOL_FOR_THOUSAND,
        million: SYMBOL_FOR_MILLION,
        billion: SYMBOL_FOR_BILLION,
    },
    en: {
        thousand: SYMBOL_FOR_THOUSAND_ENG,
        million: SYMBOL_FOR_MILLION_ENG,
        billion: SYMBOL_FOR_BILLION_ENG,
    },
};

const formatNumber = (value) => {
    return value
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}

export class FormatHelper
{
    /**
     * Форматирование числа с разделителем, с заменой 0 на предусмотренный символ
     * @param number number число для форматирования
     * @param suffix суффикс к числу
     * @param withZero с нулём?
     * @returns string
     */
    static number(number, suffix = "", withZero = false)
    {
        if (number === 0 || number === undefined || number === null) {
            return withZero ? 0 : SYMBOL_FOR_ZERO;
        }

        if (suffix.length > 0) {
            suffix = " " + suffix;
        }

        return formatNumber(number) + suffix;
    }

    /**
     * @param number number число для форматирования
     * @param suffix суффикс к числу
     * @returns string
     */
    static nullableNumber(number, suffix = "") {
        const numericValue = Number(number);

        if (number === null || number === undefined || !Number.isFinite(numericValue)) {
            return SYMBOL_FOR_ZERO;
        }

        if (suffix.length > 0) {
            suffix = " " + suffix;
        }

        return formatNumber(number) + suffix;
    }

    /**
     * Форматирование числа с разделителем, возможен 0
     * @param number number число для форматирования
     * @param suffix суффикс к числу
     * @returns string
     */
    static numberWithZero(number, suffix = "")
    {
        if (number === undefined) {
            number = 0;
        }

        if (suffix.length > 0) {
            suffix = " " + suffix;
        }

        return formatNumber(number) + suffix;
    }

    /**
     * Форматирование числа с суффиксами тысячи и миллиона
     * @param number
     * @param withZero с нулём?
     * @param lang язык суффиксов
     * @returns string
     */
    static numberDigits(number, withZero = false, lang = 'ru')
    {
        const numberDigitsData = this.getNumberDigitsData(number, withZero, lang);

        return numberDigitsData.digits
            ? numberDigitsData.number + numberDigitsData.digits
            : numberDigitsData.number;
    }

    /**
     * Получаем данные числа с суффиксами тысячи и миллиона
     * @param number
     * @param withZero с нулём?
     * @param lang язык суффиксов
     * @return {{number: number, digits: string}}
     */
    static getNumberDigitsData(number, withZero = false, lang = 'ru')
    {
        if (number === 0 || number === undefined) {
            return {
                number: withZero ? 0 : SYMBOL_FOR_ZERO,
                digits: null,
            };
        }

        if (number < 999) {
            // if value < 1000, nothing to do
            return {
                number: number,
                digits: null,
            };
        }

        if (number > 999 && number < 1000000) {
            // convert to K for number from > 1000 < 1 million
            return {
                number: Math.floor(number / 1000),
                digits: SYMBOLS[lang]['thousand'],
            };
        }

        if (number >= 1000000 && number < 1000000000) {
            // convert to M for number from > 1 million
            return {
                number: Math.floor(number / 1000000),
                digits: SYMBOLS[lang]['million'],
            };
        }

        // convert to M for number from > 1 million
        return {
            number: Math.floor(number / 1000000000),
            digits: SYMBOLS[lang]['billion'],
        };
    }

    /**
     * Добавляем нули перед числом
     * @param number
     * @param zeroPrefix
     * @return string
     */
    static numberZeroPrefix(number, zeroPrefix = 2)
    {
        return number.toString().padStart(zeroPrefix, '0');
    }

    /**
     * @param bytes
     * @param decimals
     * @returns {string}
     */
    static formatBytes(bytes, decimals = 2)
    {
        if (bytes === 0) {
            return '0';
        } else {
            const k = 1024;
            const dm = decimals < 0 ? 0 : decimals;
            const sizes = ['байт', 'КБ', 'МБ', 'ГБ', 'ТБ'];
            const i = Math.floor(Math.log(bytes) / Math.log(k));
            return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
        }
    }

    /**
     * Форматирование даты
     * @param dateResponse
     * @returns {string}
     */
    static date(dateResponse) {
        const date = new Date(dateResponse);
        const day = this.numberZeroPrefix(date.getDate());
        const month = this.numberZeroPrefix(date.getMonth() + 1);
        const year = date.getFullYear();
        return [day, month, year].join('.');
    }
}
